var Component = require("!../../../../../../develop/node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../../develop/node_modules/vue-loader/lib/selector?type=script&index=0!./404.vue"),
  /* template */
  require("!!../../../../../../develop/node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-01b3eca4\",\"hasScoped\":false}!../../../../../../develop/node_modules/vue-loader/lib/selector?type=template&index=0!./404.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/404.vue
// module id = 395
// module chunks = 0